<template>
  <v-container fluid class="home_wrapper">
    <v-row align="center" justify="center" style="height: 100%;">
      <v-slide-y-transition appear>
        <v-card color="transparent" class="pa-0 main-contents" elevation="0">
          <v-card-title class="pick-logo">
            <v-container>
              <v-row justify="center">
                <v-col cols="7" sm="4" md="4" lg="5" xl="5">
                  <v-img
                    src="@/assets/logo/medium-white.png"
                    alt="Pick logo"
                    class="block-center"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-title>
          <v-card-text class="home-title">
            <v-container fluid class="pa-0">
              <v-row
                v-for="(text, index) in business"
                :key="text.title"
                class="mb-16"
              >
                <v-col>
                  <div
                    v-if="index === 0"
                    class="text-center vision text-h3 text-sm-h2 text-md-h1 text-lg-h1 text-xl-h1 noto-serif"
                  >
                    {{ text.title }}
                  </div>
                  <div
                    v-else
                    class="text-center text-decoration-underline mb-10 text-h3 text-sm-h3 text-md-h2 text-lg-h2 text-xl-h2 noto-serif"
                  >
                    {{ text.title }}
                  </div>
                  <div
                    class="text-center mb-14 text-h4 text-sm-h4 text-md-h3 text-lg-h3 text-xl-h3 noto-serif"
                  >
                    {{ text.desc }}
                  </div>
                  <v-img
                    v-if="text.img.path"
                    :src="text.img.path"
                    max-width="80px"
                    alt="Signage pic"
                    class="block-center mb-16"
                  />
                </v-col>
              </v-row>
              <v-row
                v-for="(info, index) in company"
                :key="index"
                class="mb-16"
              >
                <v-col>
                  <div
                    class="text-center text-decoration-underline mb-10 text-h3 text-sm-h3 text-md-h2 text-lg-h2 text-xl-h2 noto-serif"
                  >
                    {{ info.title }}
                  </div>
                  <div
                    v-for="(item, index) in info.items"
                    :key="index"
                    class="text-center text-h4 text-sm-h4 text-md-h3 text-lg-h3 text-xl-h3 noto-serif"
                  >
                    {{ item.topic }}：{{ item.desc }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
  components: {},

  data: () => ({
    business: [
      {
        title: '「体験」を情報化する。',
        desc:
          '情報化社会と呼ばれて久しい現代、データ化されているのはスマホやPCの中ばかり。人の視覚・聴覚・触覚といった感覚器の情報はいまだ有効に取得・活用されていません。ピックノートは、人の感覚をデータ化し３次元空間情報と紐づけることにより、「体験」そのものを情報化します。',
        img: {
          path: '',
          altMsg: ''
        }
      },
      {
        title: 'AIサイネージ事業',
        desc:
          '画像解析により性別・年齢・視線・手の動きなど人の行動を分析し、小売や施設に訪れた人の店舗体験を可視化します。リアルタイムでサイネージに反映させることで販促効果を上げると同時に、取得したデータは非購買層まで含めた顧客の関心情報として統計化されます。（エッジコンピューティングにより、分析に使用した画像データはリアルタイムで消去され、個人情報を一切残しません。）',
        img: {
          path: require('@/assets/logo/hm_signage.png'),
          altMsg: 'Singage Pic'
        }
      },
      {
        title: 'BIM/CADシステム開発事業',
        desc:
          '建築・土木の分野ではBIMが普及し、3DCGのモデルに情報を乗せることで従来のアナログな作業を効率化していく流れがあります。しかし、BIMは誰にでも使える簡単なツールではなく、導入するハードルは高いままです。ピックノートでは、画像解析やクラウド等のBIMの外側の技術をBIMに組み込んだ、顧客企業が欲しいと考える機能だけがより感覚的に使えるアドインを開発し、BIMの導入を支援しています。',
        img: {
          path: require('@/assets/logo/hm_bim.png'),
          altMsg: 'BIM Pic'
        }
      },
      {
        title: 'VR事業',
        desc:
          'VRは視覚・聴覚・触覚を同時に伝達する媒体として非常に優れており、近年急速に発達しているOculus等のハードウェアによって、「体験」をヴァーチャルに再現することが可能です。ピックノートでは、現実に体験することにコストがかかる特に「学習」に関する体験にフォーカスし、VR開発を行っています。',
        img: {
          path: require('@/assets/logo/hm_vr.png'),
          altMsg: 'VR Pic'
        }
      }
    ],
    company: [
      {
        title: '会社概要',
        items: [
          { topic: '会社名', desc: '株式会社ピックノート' },
          { topic: '設立', desc: '2018年9月10日' },
          { topic: '資本金', desc: '300万円' },
          { topic: '所在地', desc: '東京都品川区大井2-8-15' },
          { topic: '代表', desc: '山本直弥' }
        ]
      },
      {
        title: 'お問合せ',
        items: [
          {
            topic: 'mail',
            desc: 'naoya@picknote.co'
          },
          {
            topic: '担当',
            desc: '山本'
          }
        ]
      }
    ]
  })
}
</script>
<style scoped>
.main-contents {
  max-width: 800px;
  width: 100%;
}
.home_wrapper {
  margin-top: 13%;
}
.noto-serif {
  font-family: 'Noto Serif JP', serif !important;
}
.home-title {
  font-size: 1.2rem;
  font-kerning: auto;
  line-height: 2.4rem;
}
.pick-logo {
  margin-bottom: 8%;
}
.vision {
  margin-bottom: 25%;
}
.block-center {
  margin-left: auto;
  margin-right: auto;
}
.text-center {
  text-align: center;
}
</style>
